import React, {Fragment} from "react";


const CardTitle = (props) => {

  

  return (
    <h4 className={`cardTitle ${props.className || ''}`} style={props.style} id={props.id || ''}>{props.children}</h4>
  );

}


export default CardTitle;
